import React from 'react';

const TRANSACTION_METHODS = ['all', 'merchantPay', 'mobilemoney', 'manualBank', 'admin'];

export const Filters = ({
  onDaysChange,
  setTransactionStatus,
  setActiveTransactionMethod,
  onStatusChange,
  transactionType,
  transactionStatus,
  activeTransactionMethod,
}) => {
  const [daysFilter, setDaysFilter] = React.useState('7');

  const validMethods =
    transactionType === 'withdraw'
      ? TRANSACTION_METHODS.filter((m) => m !== 'merchantPay')
      : TRANSACTION_METHODS;

  const statuses = ['swap', 'transfer'].includes(transactionType)
    ? ['successful', 'failed']
    : ['all', 'successful', 'failed', 'pending'];

  return (
    <div className="flex flex-wrap gap-4 items-center justify-between">
      {/* Days Filter */}
      <div className="flex flex-col">
        <select
          id="daysFilter"
          value={daysFilter}
          onChange={(e) => {
            const value = e.target.value;
            setDaysFilter(value);
            onDaysChange(value);
          }}
          className="px-3 py-2 rounded-full bg-white/20 text-white shadow-inner backdrop-blur-md focus:outline-none focus:ring-2 focus:ring-white/20 text-sm"
        >
          <option value="7">Last 7 Days</option>
          <option value="30">Last 30 Days</option>
          <option value="90">Last 90 Days</option>
        </select>
      </div>

      {/* Payment Methods */}
      {transactionType !== 'transfer' && transactionType !== 'swap' && (
        <div className="flex items-center gap-2 bg-white/10 backdrop-blur-md rounded-full px-2 py-1 shadow-sm">
          {validMethods.map((method) => (
            <button
              key={method}
              onClick={() => setActiveTransactionMethod(method)}
              className={`capitalize text-sm px-3 py-1 rounded-full transition-all duration-200 ${
                activeTransactionMethod === method
                  ? 'bg-[#01B9FF]/30 text-white font-medium shadow-sm'
                  : 'text-white/60 hover:text-white'
              }`}
            >
              {method}
            </button>
          ))}
        </div>
      )}

      {/* Status Filter */}
      <div className="flex flex-col">
        <select
          id="statusFilter"
          value={transactionStatus}
          onChange={(e) => {
            const value = e.target.value;
            setTransactionStatus(value);
            onStatusChange(value);
          }}
          className="px-3 py-2 rounded-full bg-white/20 text-white shadow-inner backdrop-blur-md focus:outline-none focus:ring-2 focus:ring-white/20 text-sm"
        >
          {statuses.map((status) => (
            <option key={status} value={status} className="capitalize">
              {status}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
